module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/5_7344fd44cf4507efea917d19e115d6fb.png";